import React from 'react';
import { image } from '../../../../../utils/data/baseUrl';
import { safeHTML } from '../../../../../utils/safeHTML';
import CustomButton from '../../../customButton/ui/main/CustomButton';
import { isString } from 'lodash';
import classNames from 'classnames';
import { PRICE } from '../../constants/modes';
import { MAX_DESCRIPTION_LENGTH_FOR_SINGLE_LINE } from '../../constants/content';

export default function Header({ noCode, isVisibleInfo = true, description, title, favoriteCallback }) {
  const Wrapper = getWrapper(arguments[0]);
  const isShortDescription = isString(description) && description.length <= MAX_DESCRIPTION_LENGTH_FOR_SINGLE_LINE;

  return (
    <Wrapper>
      {!noCode && (
        <div className={'product__code'}>
          <img src={image(`modals/code.svg`)} />
        </div>
      )}

      <div
        className={classNames('product__info', {
          product__info_short: isShortDescription,
        })}
      >
        {isString(description) && <div className={'product__brand'}>{safeHTML(description)}</div>}
        <div className={classNames('product__del', 'product__del_header')} />
        {isVisibleInfo && <CustomButton className={'product__like'} icon={'buttons/like'} onClick={favoriteCallback} />}
      </div>

      <div className={'product__type'}>{safeHTML(title)}</div>
    </Wrapper>
  );
}

function getWrapper({ mode }) {
  const wrappers = {
    [PRICE]: ({ children }) => <div className={'product__header'}>{children}</div>,
    default: ({ children }) => <>{children}</>,
  };

  return wrappers[mode] ?? wrappers.default;
}
